import React, { useState, useEffect, useContext } from 'react';
// import { GET } from 'utils/useApi';
import Layout from 'antd/lib/layout/layout';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router-dom';
import { LayoutProp } from 'types/Content';
import { NotificationProvider } from 'context/NotificationContext';
import { getAuthHeader } from 'api/request';
import { useLocation } from 'react-router';
import HeaderNav from 'components/HeaderNav';
import Footer from 'components/Footer';
import DashboardFooter from 'components/Footer/DashboardFooter';
import SignInUpModal from 'components/SignInUpModal';
import AuthContext from 'context/AuthContext';

const { Content } = Layout;

const NO_FOOTER_PREFIXES = [
  '/post-job',
  '/customer/',
  '/customer-dashboard',
  '/dashboard',
  '/signup',
  '/post',
  '/browse',
  '/messages',
  '/bookings',
  '/a-level-retakes',
  '/profile',
  '/customer-profile',
  '/customer-feedback',
  '/tutor-reference',
  '/booking',
  '/jobs'
];

const VERIFY_MAIL_BANNER_PREFIXES = [
  '/messages',
  '/customer-dashboard',
  '/bookings',
  '/customer/jobs',
];

const DASHBOARD_FOOTER_PREFIXES = [
  '/customer-dashboard',
  '/dashboard',
  '/messages',
  '/bookings',
  '/profile',
  '/customer-profile',
  '/customer-feedback',
  '/tutor-reference',
  '/booking',
  '/post',
  '/jobs'
];

function AppLayout(props: LayoutProp) {
  const { pathname } = useLocation();

  const authToken = getAuthHeader()
    .Authorization.replace('Token', '')
    .trim();
  const auth = useContext(AuthContext);
  const { REACT_APP_WS_ENDPOINT } = process.env;

  const [unreadMessagesCount, setUnreadMessagesCount] = useState(0);
  const [unreadNotificationsCount, setUnreadNotificationsCount] = useState(0);
  const [webSocket, setWebSocket] = useState<WebSocket>();

  const showFooter = !NO_FOOTER_PREFIXES.find(prefix =>
    props.location.pathname.startsWith(prefix)
  );

  const showDashboardFooter = !!DASHBOARD_FOOTER_PREFIXES.find(prefix =>
    props.location.pathname.startsWith(prefix)
  );

  const showBanner = !!VERIFY_MAIL_BANNER_PREFIXES.find(prefix =>
    props.location.pathname.startsWith(prefix)
  );

  // const getUnreadNotifications = async () => {
  //   const useToken = true;
  //   try {
  //     const result = (await GET(
  //       'v2/notifications/unread_count/',
  //       useToken
  //     )) as any;
  //     setUnreadMessagesCount(result.data.unread_message_count);
  //     setUnreadNotificationsCount(result.data.unread_notification_count);
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  const getNewSocket = () => {
    try {
      const ws = new WebSocket(`${REACT_APP_WS_ENDPOINT}/?token=${authToken}`);
      setWebSocket(ws);
    }catch (err){
      console.log(err)
    }
  };

  const notificationCtx = {
    unreadMessagesCount,
    unreadNotificationsCount,
    setUnreadMessagesCount,
    setUnreadNotificationsCount,
    // getUnreadNotifications,
    getNewSocket,
    webSocket
  };

  useEffect(() => {
    if (authToken && authToken !== null) {
      getNewSocket();
    }
  }, [REACT_APP_WS_ENDPOINT, authToken]);

  return (
    <NotificationProvider value={notificationCtx}>
      <Helmet>
        {pathname !== '/' && (
          <script async src="https://js.stripe.com/v3/"></script>
        )}
      </Helmet>
      <Layout
        className="layout"
        style={{ minHeight: 'calc(100vh - 64px)', background: '#fff' }}
      >
        <HeaderNav showBanner={showBanner} />
        <Content>{props.children}</Content>
        {showFooter && <Footer />}
        {showDashboardFooter && <DashboardFooter />}
        {!auth.authToken && <SignInUpModal
          onSuccess={(u) => {}}
          visible={auth.isSignupModalVisible}
          onCancel={() => auth.setSignupModalVisibility(false)}
        />}
      </Layout>
    </NotificationProvider>
  );
}

export default withRouter((props: LayoutProp) => (
  <AppLayout {...props}>{props.children}</AppLayout>
));
